<template>
    <div>
        <feedback-form v-show="showForm" ref="feedbackForm"
                       :show-comment="false"
                       :title="title"
                       :description="$lang('сorporate.descr')"
                       @send-form="submit">
        </feedback-form>
        <el-dialog class="popup popup--success"
                   :width="windowWidth > 992 ? '770px' : '75%'"
                   top="50vh"
                   :append-to-body="true"
                   :visible.sync="showNotify">
            <span class="popup__success">{{ $lang('сorporate.success') }}</span>
        </el-dialog>
    </div>
</template>

<script>
import ApiService from "../api/api";
import FeedbackForm from "./FeedbackForm";
import Vue from "vue";

export default {
    name: "FeedbackForPartner",
    components: {FeedbackForm},
    props: {
        title: {
            type: String,
            default: Vue.prototype.$lang('сorporate.title')
        },
        url: {
            type: String,
            default: '/partner/corporate'
        },
        categoryForAmo: {
            type: String,
            default: Vue.prototype.$lang('сorporate.category')
        }
    },
    data: () => ({
        showForm: false,
        showNotify: false,
    }),
    watch: {
        showNotify: {
            handler(val) {
                if (!val && !this.showForm) {
                    this.$router.back();
                }
            },
            deep: true
        }
    },
    methods: {
        submit: function(form) {
            return new Promise((resolve, reject) => {
                this.showForm = false;

                this.$loading(this.$optionsLoading);

                let extendedForm = {
                    ...form,
                    ...{ category: this.categoryForAmo }
                };

                ApiService.post(this.url, extendedForm)
                    .then((response) => {
                        this.showNotify = true;

                        this.$refs.feedbackForm.$emit('reset-form');

                        if (this.$route.name === 'corporate') {
                            this.$dataLayer.push({'event': 'сorporateRequestSended'});
                        } else {
                            this.$dataLayer.push({'event': 'PartnerRequestSended'});
                        }
                    })
                    .catch((error) => {
                        if(error.response.data.errors) {
                            this.showForm = true;

                            this.$refs.feedbackForm.$emit('show-errors', error.response.data.errors);
                        } else {
                            this.$router.back();

                            this.$appNotify.error(Vue.prototype.$lang('сorporate.error'));
                        }
                    })
                    .finally(() => {
                        this.$loading({}).close();

                        setTimeout(() => this.showNotify = false, 4000);
                    });
            });
        }
    },
    beforeMount() {
        this.showForm = true;
    }
}
</script>
